import { render, staticRenderFns } from "./Conexao4G.vue?vue&type=template&id=715837b4"
import script from "./Conexao4G.vue?vue&type=script&lang=js"
export * from "./Conexao4G.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports